(() => {
  const lockBody = () => document.documentElement.classList.add('laf-sg-open');
  const unlockBody = () => document.documentElement.classList.remove('laf-sg-open');

  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-laf-sg-open]');
    if (opener) {
      const dialog = document.getElementById(opener.getAttribute('data-laf-sg-open'));
      if (dialog && typeof dialog.showModal === 'function') {
        dialog.showModal();
        lockBody();
      }
    }

    const closer = event.target.closest('[data-laf-sg-close]');
    if (closer) {
      const dialog = closer.closest('dialog');
      if (dialog) dialog.close();
    }

    const tab = event.target.closest('[data-laf-sg-tab]');
    if (tab) activatePanel(tab.dataset.lafSgTab, tab.closest('.laf-sg-page__main'));

    const refine = event.target.closest('[data-laf-sg-refine]');
    if (refine) {
      const advisor = refine.closest('[data-laf-sg-advisor]');
      const panel = advisor && advisor.querySelector('[data-laf-sg-refine-panel]');
      if (panel) {
        const willOpen = panel.hidden;
        panel.hidden = !willOpen;
        refine.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
        refine.textContent = willOpen ? '− Masquer les mesures complémentaires' : '+ Affiner avec mes mensurations';
      }
    }

    const calculate = event.target.closest('[data-laf-sg-calc]');
    if (calculate) calculateRecommendation(calculate.closest('[data-laf-sg-advisor]'));
  });

  document.addEventListener('close', (event) => {
    if (event.target.matches && event.target.matches('.laf-sg-dialog')) unlockBody();
  }, true);

  document.addEventListener('cancel', (event) => {
    if (event.target.matches && event.target.matches('.laf-sg-dialog')) unlockBody();
  }, true);

  document.addEventListener('change', (event) => {
    if (event.target.matches('[data-laf-sg-select]')) {
      activatePanel(event.target.value, event.target.closest('.laf-sg-page__main'));
    }
  });

  function activatePanel(handle, root) {
    if (!root) return;
    root.querySelectorAll('[data-laf-sg-panel]').forEach((panel) => {
      panel.hidden = panel.dataset.lafSgPanel !== handle;
    });
    root.querySelectorAll('[data-laf-sg-tab]').forEach((button) => {
      const active = button.dataset.lafSgTab === handle;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-selected', active ? 'true' : 'false');
    });
    const select = root.querySelector('[data-laf-sg-select]');
    if (select && select.value !== handle) select.value = handle;
  }

  const FIELD_MAP = {
    height: ['heightMin', 'heightMax'],
    weight: ['weightMin', 'weightMax'],
    chest: ['chestMin', 'chestMax'],
    waist: ['waistMin', 'waistMax'],
    hips: ['hipsMin', 'hipsMax'],
    underbust: ['underbustMin', 'underbustMax'],
    inseam: ['inseamMin', 'inseamMax'],
    shoe: ['shoeMin', 'shoeMax'],
    arm: ['armMin', 'armMax']
  };

  const FIELD_WEIGHTS = {
    height: 0.8,
    weight: 1,
    arm: 2.2,
    chest: 1.55,
    waist: 1.5,
    hips: 1.35,
    underbust: 1.65,
    inseam: 0.8,
    shoe: 1.8
  };

  function parseProfiles(advisor) {
    try {
      const node = advisor.querySelector('[data-laf-sg-data]');
      const parsed = JSON.parse(node ? node.textContent : '[]');
      return Array.isArray(parsed) ? parsed : [];
    } catch (_) {
      return [];
    }
  }

  function collectInputs(advisor) {
    const values = {};
    advisor.querySelectorAll('[data-laf-sg-input]').forEach((input) => {
      const raw = String(input.value || '').trim().replace(',', '.');
      const value = Number(raw);
      if (raw !== '' && Number.isFinite(value)) values[input.dataset.lafSgInput] = value;
    });
    return values;
  }

  function rangeDistance(value, min, max) {
    if (min == null && max == null) return null;
    if (min == null) min = max;
    if (max == null) max = min;
    min = Number(min);
    max = Number(max);
    if (!Number.isFinite(min) || !Number.isFinite(max)) return null;
    if (min > max) [min, max] = [max, min];
    const span = Math.max(max - min, 1);

    if (value < min) return 0.65 + (min - value) / span;
    if (value > max) return 0.65 + (value - max) / span;

    const midpoint = (min + max) / 2;
    return Math.abs(value - midpoint) / Math.max(span / 2, 1) * 0.08;
  }

  function scoreProfile(profile, values) {
    let score = 0;
    let usedWeight = 0;
    let usedFields = 0;
    const providedFields = Object.keys(values);

    providedFields.forEach((field) => {
      const keys = FIELD_MAP[field];
      if (!keys) return;
      const distance = rangeDistance(values[field], profile[keys[0]], profile[keys[1]]);
      if (distance == null) return;
      const weight = FIELD_WEIGHTS[field] || 1;
      score += distance * weight;
      usedWeight += weight;
      usedFields += 1;
    });

    if (!usedFields) return null;

    const ignored = Math.max(0, providedFields.length - usedFields);
    const normalized = score / Math.max(usedWeight, 0.1) + ignored * 0.28;
    return { profile, score: normalized, usedFields };
  }

  function valueInsideRange(value, min, max) {
    if (min == null && max == null) return false;
    if (min == null) min = max;
    if (max == null) max = min;
    min = Number(min);
    max = Number(max);
    if (!Number.isFinite(min) || !Number.isFinite(max)) return false;
    if (min > max) [min, max] = [max, min];
    return value >= min && value <= max;
  }

  function profileAtOffset(profiles, current, offset) {
    const ordered = [...profiles].sort((a, b) => Number(a.order || 0) - Number(b.order || 0));
    const index = ordered.findIndex((profile) => profile === current || (profile.size === current.size && Number(profile.order || 0) === Number(current.order || 0)));
    if (index < 0) return current;
    return ordered[Math.max(0, Math.min(ordered.length - 1, index + offset))] || current;
  }

  function calculateRecommendation(advisor) {
    if (!advisor) return;
    const profiles = parseProfiles(advisor);
    const values = collectInputs(advisor);
    const result = advisor.querySelector('[data-laf-sg-result]');
    const resultSize = advisor.querySelector('[data-laf-sg-result-size]');
    const resultCopy = advisor.querySelector('[data-laf-sg-result-copy]');
    const resultKicker = advisor.querySelector('[data-laf-sg-result-kicker]');
    const kind = advisor.dataset.guideKind || 'garment';

    if (!result || !resultSize || !resultCopy || !resultKicker) return;

    if (!Object.keys(values).length) {
      result.hidden = false;
      result.classList.add('is-warning');
      resultKicker.textContent = 'Il nous manque une information';
      resultSize.textContent = '—';
      resultCopy.textContent = kind === 'socks'
        ? 'Indiquez votre pointure habituelle pour obtenir notre recommandation.'
        : 'Renseignez au moins une mesure disponible pour obtenir une recommandation.';
      return;
    }

    if (kind === 'socks' && Number.isFinite(values.shoe)) {
      const matches = profiles
        .filter((profile) => valueInsideRange(values.shoe, profile.shoeMin, profile.shoeMax))
        .sort((a, b) => Number(a.order || 0) - Number(b.order || 0));

      if (matches.length) {
        result.hidden = false;
        result.classList.remove('is-warning');
        resultKicker.textContent = 'Selon votre pointure';
        if (matches.length > 1) {
          resultSize.textContent = matches.map((profile) => profile.size).join(' / ');
          resultCopy.textContent = `Votre pointure ${values.shoe} se situe à la jonction de nos deux tailles. Choisissez ${matches[0].size} pour un ajustement plus près du pied, ou ${matches[matches.length - 1].size} pour davantage d’aisance.`;
        } else {
          resultSize.textContent = matches[0].size || '—';
          resultCopy.textContent = `Pour une pointure ${values.shoe}, nous vous conseillons la taille ${matches[0].size}.`;
        }
        return;
      }
    }

    const scored = profiles
      .map((profile) => scoreProfile(profile, values))
      .filter(Boolean)
      .sort((a, b) => a.score - b.score || Number(a.profile.order || 0) - Number(b.profile.order || 0));

    if (!scored.length) {
      result.hidden = false;
      result.classList.add('is-warning');
      resultKicker.textContent = 'À affiner';
      resultSize.textContent = '—';
      resultCopy.textContent = 'Les informations renseignées ne correspondent pas encore aux plages configurées pour ce guide. Ajoutez une mensuration disponible pour affiner.';
      return;
    }

    result.classList.remove('is-warning');
    const best = scored[0];
    const second = scored[1];
    const fit = advisor.querySelector('[data-laf-sg-fit]')?.value || 'standard';
    const close = second && Math.abs(second.score - best.score) < 0.16;
    let chosen = best;
    let secondary = null;
    let oversizeShifted = false;

    if (kind === 'oversize') {
      let shiftedProfile = best.profile;
      if (fit === 'adjusted') shiftedProfile = profileAtOffset(profiles, best.profile, -1);
      if (fit === 'relaxed') shiftedProfile = profileAtOffset(profiles, best.profile, 1);
      if (shiftedProfile !== best.profile) {
        chosen = { ...best, profile: shiftedProfile };
        oversizeShifted = true;
      }
    } else if (close) {
      const pair = [best, second].sort((a, b) => Number(a.profile.order || 0) - Number(b.profile.order || 0));
      if (fit === 'adjusted') chosen = pair[0];
      else if (fit === 'relaxed') chosen = pair[pair.length - 1];
      secondary = pair.find((item) => item !== chosen) || null;
    }

    const size = chosen.profile.size || '—';
    const preciseFields = ['arm', 'chest', 'waist', 'hips', 'underbust', 'inseam', 'shoe'].filter((field) => Number.isFinite(values[field])).length;
    const confidence = preciseFields >= 2 ? 'très affinée' : preciseFields === 1 ? 'affinée' : 'indicative';
    const fitAdvice = advisor.dataset.fitAdvice || '';

    result.hidden = false;
    resultKicker.textContent = `Recommandation ${confidence}`;
    resultSize.textContent = size;

    if (kind === 'oversize' && oversizeShifted) {
      if (fit === 'adjusted') {
        resultCopy.textContent = `Votre taille de référence est ${best.profile.size}. Pour obtenir un rendu moins ample sur cette coupe oversize, nous vous conseillons ${size}.${fitAdvice ? ' ' + fitAdvice : ''}`;
      } else {
        resultCopy.textContent = `Votre taille de référence est ${best.profile.size}. Pour accentuer l’effet oversize, nous vous conseillons ${size}.${fitAdvice ? ' ' + fitAdvice : ''}`;
      }
    } else if (kind === 'oversize') {
      resultCopy.textContent = `D’après les informations renseignées, ${size} est votre meilleur point de départ pour conserver l’effet oversize prévu.${fitAdvice ? ' ' + fitAdvice : ''}`;
    } else if (close && secondary) {
      resultCopy.textContent = `Vous êtes proche des tailles ${chosen.profile.size} et ${secondary.profile.size}. Votre préférence de coupe nous fait privilégier ${size}.${fitAdvice ? ' ' + fitAdvice : ''}`;
    } else {
      resultCopy.textContent = `D’après les informations renseignées, la taille ${size} est le meilleur point de départ.${fitAdvice ? ' ' + fitAdvice : ''}`;
    }
  }})();
